import requestOptions from './RequestOptions'
import ConfiguracionMapper from '../models/Configuracion_Mapper'
import GeneralMapper from '../models/General_Mapper'
import urlServices from "../../environments/API"
const urlConfiguracion = urlServices.configuracion

const tableroService = async (idTablero, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filters = '?idTablero=' + idTablero + '&page=' + page + '&perPage=' + perPage
    if (search !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_TABLEROS + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idTablero !== 0) {
        response = ConfiguracionMapper.tableroByIdMapper(data.data)
      } else {
        response = ConfiguracionMapper.tableroMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveEditTableroService = async (dataToSave) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(urlConfiguracion + global.POST_TABLEROS, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveEditAreaService = async (dataToSave) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(urlConfiguracion + global.POST_AREAS, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const areasService = async (idArea, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filters = '?idArea=' + idArea + '&page=' + page + '&perPage=' + perPage
    if (search.trim() !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_AREAS + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idArea !== 0) {
        response = ConfiguracionMapper.areasByIdMapper(data.data)
      } else {
        response = ConfiguracionMapper.areasMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const areasBiService = async (idArea, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filters = '?idArea=' + idArea + '&page=' + page + '&perPage=' + perPage
    if (search.trim() !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_AREAS + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idArea !== 0) {
        response = ConfiguracionMapper.areasByIdBIMapper(data.data.listTablero)
      } else {
        response = ConfiguracionMapper.areasMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const tabRoleUserService = async (idTablero) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    const resp = await fetch(urlConfiguracion + global.GET_TABLEROS_ROLE_USER + '?idTablero=' + idTablero, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = await ConfiguracionMapper.tableroByRolByUserMapper(data.data.tablero)
    } else {
      response = await GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveTabRoleUserService = async (dataToSave) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(urlConfiguracion + global.POST_TABLEROS_ROLE_USER, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const areasNewBiService = async (idArea, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    const param = JSON.parse(localStorage.getItem('data'));
    let filters = '?codigoUsuario=' + param["codigoUsuario"] + '&page=' + page + '&perPage=' + perPage
    if (search.trim() !== "") {
      filters += '&nombreArea=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_AREAS_BI + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idArea !== 0) {
        response = ConfiguracionMapper.areasNewByIdBIMapper(data.data.listTablero)
      } else {
        response = ConfiguracionMapper.areasNewBiMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const tableroXAreasBiService = async (idArea, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    const param = JSON.parse(localStorage.getItem('data'));
    let filters = '?idArea=' + idArea + '&codigoUsuario=' + param["codigoUsuario"] + '&page=' + page + '&perPage=' + perPage
    if (search.trim() !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_TABLAS_AREAS_BI + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = ConfiguracionMapper.tableroXAreasNewBiMapper(data.data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const empresasService = async (idEmpresa, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filters = '?idEmpresa=' + idEmpresa + '&page=' + page + '&perPage=' + perPage
    if (search.trim() !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_EMPRESAS + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idEmpresa !== 0) {
        response = ConfiguracionMapper.empresasyIdMapper(data.data)
      } else {
        response = ConfiguracionMapper.empresasMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveEditEmpresaService = async (dataToSave) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(urlConfiguracion + global.POST_EMPRESAS, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const usuariosConfigService = async (idUsuarioConfig, page, perPage, search = "", tipoUsuario) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filters = '?secuenciaPersonal=' + idUsuarioConfig + '&page=' + page + '&perPage=' + perPage + '&tipoUsuario=' + tipoUsuario
    if (search.trim() !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_CONFIG_USER + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idUsuarioConfig !== 0) {
        response = ConfiguracionMapper.usuariosConfigIdMapper(data.data)
      } else {
        response = ConfiguracionMapper.usuariosConfigMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveEditUsuariosConfigService = async (dataToSave, saveType) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(urlConfiguracion + global.POST_CONFIG_USER, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (saveType !== 'D') {
        const secondPayload = {
          codigoUsuario: dataToSave.codigoUsuario,
          codigoEmpresa: global.EMP_CODE,
          listRoles: [
            {
              codigoRol: dataToSave.rol,
              esActivo: "S",
              usuarioCreacion: localStorage.getItem('userName'),
              usuarioModificacion: localStorage.getItem('userName')
            }
          ]
        };

        const secondOptions = requestOptions.optionsConfig('POST', token, secondPayload);
        const secondResp = await fetch(urlConfiguracion + "/seguridad/rol/asignar_rol_usuario", secondOptions);
        const secondData = await secondResp.json();
        if (secondData.success && secondData.code === global.SUCCESS_CODE) {
          response = GeneralMapper.responseMapper(data)
        } else {
          response = GeneralMapper.responseMapper(data)
        }
      } else {
        response = GeneralMapper.responseMapper(data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const grupoService = async (idGrupo, page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filters = '?idGrupoEmpresa=' + idGrupo + '&page=' + page + '&perPage=' + perPage
    if (search.trim() !== "") {
      filters += '&nombreBusqueda=' + search;
    }
    const resp = await fetch(urlConfiguracion + global.GET_GROUP + filters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      if (idGrupo !== 0) {
        response = ConfiguracionMapper.groupIdMapper(data.data)
      } else {
        response = ConfiguracionMapper.groupMapper(data.data)
      }
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveEditGroupService = async (dataToSave) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(urlConfiguracion + global.POST_GROUP, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const getTokenBI = async (idDataset, idReporte) => {
  let response
  try {
    const payload = {
      idReport: idReporte
    }
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, payload)
    const resp = await fetch(urlConfiguracion + global.GET_TOKEN_BI, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const configuracionServices = {
  tableroService,
  areasService,
  saveEditTableroService,
  saveEditAreaService,
  areasBiService,
  tabRoleUserService,
  saveTabRoleUserService,
  areasNewBiService,
  tableroXAreasBiService,
  empresasService,
  usuariosConfigService,
  saveEditEmpresaService,
  grupoService,
  saveEditGroupService,
  saveEditUsuariosConfigService,
  getTokenBI
}

export default configuracionServices
